import React, { useEffect, useState } from "react";
import {
  convertUTCtoLocalDate,
  convertUTCtoLocalTime,
} from "../../utils/CommonUtils";
import { CircularProgress, Tooltip } from "@mui/material";
import {
  archiveUserService,
  getDashboardUsers,
} from "../../services/DashboardServices";
import { useNavigate } from "react-router-dom";
import dropdown from "../../assets/Icons/dropdown.svg";
import searchIcon from "../../assets/Icons/search-line.svg";
import AcknowledgeUserDelete from "../../components/Common/AcknowledgeUserDelete/AcknowledgeUserDelete";
import UnarchiveOutlinedIcon from "@mui/icons-material/UnarchiveOutlined";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ExportUsersData from "../../components/Common/ExportUsersData/ExportUsersData";
import { useOrgContext } from "../../Context/orgContext";

const ListOfUsers = ({ handleRefresh, clinicId }) => {
  const [page, setPage] = useState(0);
  const [pageMetaData, setPageMetaData] = useState({}); //{page: 0, total_pages: 0, total_records: 0, per_page: 0}
  const [dashboardData, setDashboardData] = useState([]);
  const [search, setSearch] = useState(null); //search by username, email id
  const [ searchInput , setSearchInput ] = useState("");
  const [filter, setFilter] = useState(null); //filter by status
  const [sort, setSort] = useState(null); //sort by latest first
  const navigate = useNavigate();
  const [ userLoading , setUserLoading ] = useState(false);
  const [openAcknowledgeUserDelete, setOpenAcknowledgeUserDelete] = useState({
    open: false,
    data: null,
  });
  const { orgDetails, isOrgAdmin } = useOrgContext();
  const [ prevClinicId , setPreviousClinicId ] = useState(null);
  const [ prevSearch , setPrevSearch ] = useState('');

  useEffect(() => {
    if( prevClinicId === clinicId ){
      setUserLoading(true);
      getDashboardUsers({page, sort, filter, searchParam:search, selectedClinicCode: clinicId}).then((res) => {
        if( search === prevSearch ){
          setDashboardData(prev => [ ...prev , ...res.data.user_report_details_list]);
        }else{
          setDashboardData(res.data.user_report_details_list);
        }
        setPageMetaData(res.data);
        setPreviousClinicId(clinicId);
        setUserLoading(false);
        setPrevSearch(search);
      });
    }else{
      setPage(0);
      setUserLoading(true);
      getDashboardUsers({page: 0, sort, filter, searchParam:search, selectedClinicCode: clinicId}).then((res) => {
        setDashboardData(res.data.user_report_details_list);
        setPageMetaData(res.data);
        setPreviousClinicId(clinicId);
        setUserLoading(false);
      });
    }
  }, [search, filter, sort, clinicId, page ]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setPage(0);
      setSearch(searchInput);
    }, 500);

    return () => clearTimeout(timer);
  } , [ searchInput ]);

  return (
    <>
      <div>
        <div className="mb-5">
          <input
            type="search"
            placeholder="Search by Username, Email Id..."
            name=""
            id=""
            className="w-full outline-none px-10 py-3 rounded-[10px]"
            style={{
              border: "1px solid #EAECF0",
              backgroundImage: `url(${searchIcon})`,
              paddingLeft: "50px",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "20px center",
            }}
            onChange={(e) => setSearchInput(e.target.value)}
          />
        </div>
        <div className="bg-[#fff] px-6 py-5 flex items-center justify-between">
          <div>
            All Users{" "}
            <span className="text-[#5A6AF6] text-xs font-medium px-2 py-1 bg-[#F9F5FF] rounded-2xl">
              {pageMetaData && pageMetaData.total_user_count} Users
            </span>
          </div>
          <div className="flex gap-3">
            <select
              name=""
              id=""
              className="outline-none rounded appearance-none  px-3 py-2"
              style={{
                border: "1px solid #E1E5EB",
                backgroundImage: `url(${dropdown})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right 10px center",
                backgroundSize: "20px",
                paddingRight: "30px",
              }}
              onChange={(e) => {
                setPage(0);
                setFilter(e.target.value);
              }}
            >
              <option value="">All</option>
              <option value="viewed">Viewed</option>
              <option value="edited">Edited</option>
              <option value="new">New</option>
              <option value="archived">Archived</option>
            </select>
            <select
              name=""
              id=""
              className="outline-none rounded appearance-none  px-3 py-2"
              style={{
                border: "1px solid #E1E5EB",
                backgroundImage: `url(${dropdown})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right 10px center",
                backgroundSize: "20px",
                paddingRight: "30px",
              }}
              onChange={(e) => {
                setPage(0);
                setSort(e.target.value);
              }}
            >
              <option value="timeDsc">Sort By: Latest First</option>
              <option value="timeAsc">Sort By: Oldest First</option>
            </select>
            <ExportUsersData />
          </div>
        </div>
        <div>
          <div className="flex items-center justify-between bg-[#415280] text-[#fff]">
            <div className="w-[80px] h-11 pl-6 py-3">Sr.no</div>
            { (isOrgAdmin && clinicId === "") && <div className="w-[204px] h-11 pl-6 py-3">Client Name</div>}
            <div className="w-[204px] pl-6 py-3">Assessment Date & Time</div>
            <div className="w-[204px] h-11 pl-6 py-3">Username</div>
            <div className="w-[232px] h-11 pl-6 py-3">Email ID</div>
            <div className="w-[232px] h-11 pl-6 py-3">Status</div>
            <div className="w-[130px] h-11 pl-6 py-3">Action</div>
            <div className="w-[130px] pl-6 py-3">No.of assessments</div>
          </div>
          <div className="bg-[#fff]">
            { 
              userLoading 
               ? <div className="py-[2rem] flex justify-center items-center"><CircularProgress /></div>
               : dashboardData.length > 0 
                  ? dashboardData.map((item, index) => (
                    <div className="flex items-center justify-between py-3 border-b border-solid" key={index}>
                      <div className="w-[80px] pl-6">{item.serial_number}</div>
                      { (isOrgAdmin && clinicId === "") && <div className="w-[204px] h-11 pl-6 py-3">{item?.clinic_name}</div>}
                      <div className="w-[204px] pl-6">
                        <div className="text-[#101828] text-sm leading-5 font-medium">
                          {convertUTCtoLocalDate(
                            item.assessment_date,
                            item.assessment_time
                          )}
                        </div>
                        <div className="text-[#475467] font-normal text-sm leading-5">
                          at &nbsp;
                          {convertUTCtoLocalTime(
                            item.assessment_date,
                            item.assessment_time
                          )}
                        </div>
                      </div>
                      <div className="w-[204px] text-[#101828] text-sm leading-5 font-medium pl-6">
                        {item.username}
                      </div>
                      <div className="w-[232px] text-[#475467] text-sm leading-5 font-normal pl-6">
                        {item.email_id}
                      </div>
                      <div className="w-[232px] pl-6">
                      {
                          orgDetails.organisation_code === "simpletx" &&
                          (item.status === "Approved" ? (
                            <div className="bg-[#E0FFD9] text-xs leading-[18px] font-medium text-[#229606] w-fit px-3 py-2 cursor-pointer text-center rounded-2xl flex items-center justify-center">
                              {item.status}
                            </div>
                          ) 
                          : (
                            <div className="text-[#175CD3] text-xs leading-[18px] font-medium bg-[#EFF8FF] w-fit px-3 py-2 cursor-pointer text-center rounded-2xl flex items-center justify-center">
                              Not Approved
                            </div>
                          ))
                        }
                        {
                          orgDetails.organisation_code !== "simpletx" &&
                          (item.status === "New" ? (
                            <div className="bg-[#E0FFD9] text-xs leading-[18px] font-medium text-[#229606] w-[60px] h-[22px] text-center rounded-2xl flex items-center justify-center">
                              {item.status}
                            </div>
                          ) : item.status === "Viewed" ? (
                            <div className="">
                              <div className="text-[#175CD3] text-xs leading-[18px] font-medium bg-[#EFF8FF] w-[60px] h-[22px] text-center rounded-2xl flex items-center justify-center">
                                {item.status}
                              </div>
                              <div className="text-[#475467] font-normal text-sm leading-5">
                                on &nbsp;
                                {convertUTCtoLocalDate(
                                  item.report_last_viewed_at,
                                  item.report_last_viewed_time
                                )}
                              </div>
                            </div>
                          ) : item.status === "Email sent" ? (
                            <div className="">
                              <div className="text-[#fff] text-xs leading-[18px] font-medium bg-[#415280] w-fit h-[22px] text-center rounded-2xl flex items-center justify-center px-2">
                                {item.status}
                              </div>
                              <div className="text-[#475467] font-normal text-sm leading-5">
                                on &nbsp;
                                {convertUTCtoLocalDate(item.email_sent_time_stamp, "")}
                              </div>
                            </div>
                          ) : null)
                        }
                      </div>
                      <div className="flex w-[130px] pl-6 gap-2">
                        {/* <Button
                          sx={{
                            backgroundColor: "#788CFC",
                            color: "#fff",
                            width: "76px",
                            height: "28px",
                            "&:hover": {
                              backgroundColor: "#788CFC",
                              color: "#fff",
                            },
                          }}
                          onClick={() => {
                            navigate(`/user-data/${item.end_user_id}`);
                          }}
                        >
                          <img src={viewIcon} alt="" />
                          <div className="text-xs leading-[18px] font-medium pl-1">
                            View
                          </div>
                        </Button> */}
                        {item && !item.archived && (
                          <Tooltip title="View">
                            <VisibilityOutlinedIcon
                              onClick={() => {
                                navigate(`/user-data/${item.end_user_id}?activeTab=reports`);
                              }}
                              sx={{
                                width: "24px",
                                height: "24px",
                                color: "#788CFC",
                                cursor: "pointer",
                              }}
                            />
                          </Tooltip>
                        )}
                        {item && item.archived && (
                          <Tooltip title="Unarchive">
                            <UnarchiveOutlinedIcon
                              sx={{
                                width: "24px",
                                height: "24px",
                                color: "#788CFC",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                archiveUserService(item.end_user_id, false).then(
                                  (res) => {
                                    setPage(0);
                                    handleRefresh();
                                    getDashboardUsers({
                                      page,
                                      sort,
                                      filter,
                                      search
                                    }).then((res) => {
                                      setDashboardData(
                                        res.data.user_report_details_list
                                      );
                                      setPageMetaData(res.data);
                                    });
                                  }
                                );
                              }}
                            />
                          </Tooltip>
                        )}
                        {/* {item && !item.archived && (
                          <Button
                            sx={{
                              backgroundColor: "#F04438",
                              color: "#fff",
                              width: "76px",
                              height: "28px",
                              paddingLeft: "8px",
                              paddingRight: "8px",
                              "&:hover": {
                                backgroundColor: "#F04438",
                                color: "#fff",
                              },
                            }}
                            onClick={() => {
                              setOpenAcknowledgeUserDelete({
                                open: true,
                                data: item,
                              });
                            }}
                          >
                            <div className="text-xs leading-[18px] font-medium pl-1">
                              Archive
                            </div>
                          </Button>
                        )} */}
                        {item && !item.archived && (
                          <Tooltip title="Archive">
                            <ArchiveOutlinedIcon
                              sx={{
                                width: "24px",
                                height: "24px",
                                color: "#788CFC",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setOpenAcknowledgeUserDelete({
                                  open: true,
                                  data: item,
                                });
                              }}
                            />
                          </Tooltip>
                        )}
                      </div>
                      <div className="w-[130px] pl-6 text-center">
                        {/* <PDFButton data={item} /> */}
                        {item.total_assessments}
                      </div>
                    </div> ))
                  : <div className="w-full flex justify-center items-center py-[2rem]">No Users Found</div>
            }
          </div>
          <div className="flex justify-center">
            {pageMetaData && !pageMetaData.last_page && (
              <div
                className="bg-[#E1E1E1] rounded-[5px] mt-[70px] w-[190px] px-8 py-3 text-[#000000] font-medium text-sm leading-5 mb-[84px] cursor-pointer"
                onClick={() => {
                  console.log("page", page);
                  setPage((prev) => prev + 1);
                }}
              >
                {" "}
                Load More Users
              </div>
            )}
          </div>
        </div>
      </div>
      <AcknowledgeUserDelete
        openAcknowledgeUserDelete={openAcknowledgeUserDelete}
        closeAcknowledgeUserDelete={() =>
          setOpenAcknowledgeUserDelete({ open: false, data: null })
        }
        refresh={() => {
          setPage(0);
          getDashboardUsers({page, sort, filter, search, selectedClinicCode: clinicId}).then((res) => {
            setDashboardData(res.data.user_report_details_list);
            setPageMetaData(res.data);
          });
          handleRefresh();
        }}
      />
    </>
  );
};

export default ListOfUsers;